export enum APIInvoiceStatus {
    Unpaid = "UNPAID",
    Paid = "PAID"
}

export enum APIInvoiceItemStatus {
    Invalidated = "INVALIDATED",
    Created = "CREATED"
}

export enum APIPaymentMethodStatus {
    Active = "ACTIVE",
    Inactive = "INACTIVE"
}

export interface APIBillingAddressModel {
    name: string | null
    line1: string
    line2?: string
    city: string
    state: string
    country: string
    postalCode: string
}

export interface APIInvoiceModel {
    invoiceId: number
    ownerId: number
    amount: number
    periodStart: string
    periodEnd: string
    status: APIInvoiceStatus
    invoiceItems: {
        invoiceItemId: number
        jobId: number
        status: APIInvoiceItemStatus
        jobCreated: string
        created: string
    }[]
    created: string
    updated: string
}

export interface APIPaymentMethodModel {
    id: number
    ownerId: number
    status: APIPaymentMethodStatus
    created: string
    updated: string
    name: string
    provider: string
    token: string
    priority: number
    address?: APIBillingAddressModel
}
